import { AutoMap } from "@automapper/classes";

export class Permissions {
    @AutoMap()
    Name!: string;

    static mapFromJSON(json: any) {
        const p = new Permissions();

        p.Name = json.name;

        return p;
    }
}
